import { render, staticRenderFns } from "./PnetUtilitiesDetail.vue?vue&type=template&id=ddde4cea&scoped=true"
import script from "./PnetUtilitiesDetail.vue?vue&type=script&lang=js"
export * from "./PnetUtilitiesDetail.vue?vue&type=script&lang=js"
import style0 from "./PnetUtilitiesDetail.vue?vue&type=style&index=0&id=ddde4cea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddde4cea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddde4cea')) {
      api.createRecord('ddde4cea', component.options)
    } else {
      api.reload('ddde4cea', component.options)
    }
    module.hot.accept("./PnetUtilitiesDetail.vue?vue&type=template&id=ddde4cea&scoped=true", function () {
      api.rerender('ddde4cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/utilities/pnet/PnetUtilitiesDetail.vue"
export default component.exports